import {Empty} from 'common/empty';

const ProductsEmptyState: React.FC = () => {
  return (
    <div className="flex flex-1 items-center justify-center">
      <Empty>
        <p className="text-body-sm text-gray-08">هیچ کالایی برای نمایش وجود ندارد</p>
      </Empty>
    </div>
  );
};

export default ProductsEmptyState;
